/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC } from 'react';
import MobileHeader, { MobileHeaderProps } from './mobile';
import WidescreenHeader, { WidescreenProps } from './widescreen';

const Header: FC<{ isMobile?: boolean } & MobileHeaderProps & WidescreenProps> = ({ isMobile = false, ...rest }) => {
  return isMobile ? <MobileHeader {...rest} /> : <WidescreenHeader {...rest} />;
};

export default Header;

export { MobileHeader, WidescreenHeader };
